import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isNative } from 'app/styles';
import { exchangeLink, tokenEnabled } from 'modules/wallet/price.context';
import { goToUrl, showModal } from 'modules/navigation/navigation.actions';
import { LinkFont, Row, Box, Touchable, InlineLink } from 'modules/styled';
import { CASHOUT_MAX } from '@r3l/common';
import Tooltip from 'modules/tooltip/tooltip.component';
import { updateNotificationSettings } from 'modules/auth/auth.actions';
import { Alert } from 'utils/alert';

export default function WalletLinks() {
  const dispatch = useDispatch();
  const exchageUrl = exchangeLink();
  const user = useSelector((state) => state.auth.user);
  const isManualBet = user.notificationSettings.bet.manual;

  const toggleManualBet = () => {
    dispatch(updateNotificationSettings({ bet: { manual: !isManualBet } }));
  };

  function claimTokens() {
    return isNative
      ? Alert().alert(
          'you can claim tokens via the Relevant browser app on https://relevant.community'
        )
      : dispatch(showModal('cashOut'));
  }

  return (
    <Row sx={{ mt: 2, flexWrap: 'wrap', alignItems: 'baseline' }}>
      {isNative && (
        <Row sx={{ mr: [1, 2], mt: 1, alignItems: 'center' }}>
          <Tooltip
            name="coinInfo"
            data={{
              text: `You can get more coins or transfer up to ${CASHOUT_MAX} coins to your your Metamask wallet via the browser app on https://relevant.community.`,
            }}
          />
          <LinkFont sx={{ color: 'blue', mr: 0.5 }}>Manage Coins</LinkFont>
        </Row>
      )}

      {!isNative && (
        <Row sx={{ mr: [1, 2], mt: 1, alignItems: 'center' }}>
          <Touchable onPress={claimTokens} td={'underline'}>
            <LinkFont sx={{ color: 'blue' }}>Claim Tokens</LinkFont>
          </Touchable>
          <Box sx={{ mr: 3.99 }} />
          <Tooltip
            info
            data={{
              text: `You can transfer up to ${CASHOUT_MAX} coins to your your Metamask wallet.\n(You cannot transfer coins you got for refferrals and verifying social accounts.)`,
            }}
          />
        </Row>
      )}
      {!isNative && (
        <Row sx={{ mr: [1, 2], mt: 1, alignItems: 'center' }}>
          <Tooltip
            data={{
              text: `If you have Relevant tokens in your Metamask wallet, you need to connect your account to be able to use them.`,
            }}
          >
            <Touchable
              style={{ zIndex: 1 }}
              onPress={() => dispatch(showModal('connectMetamask'))}
              td={'underline'}
            >
              <LinkFont sx={{ color: 'blue' }}>Connect Your Wallet</LinkFont>
            </Touchable>
          </Tooltip>
        </Row>
      )}

      {tokenEnabled() && !isNative && (
        <Row sx={{ mr: [1, 2], mt: 1, alignItems: 'center' }}>
          <InlineLink to={exchageUrl} external target="_blank">
            <LinkFont
              sx={{ color: 'blue', mr: 4.0001 }}
              onPress={() => {
                dispatch(goToUrl(exchageUrl));
              }}
            >
              Get more coins
            </LinkFont>
          </InlineLink>
        </Row>
      )}

      <Row sx={{ mr: [1, 2], mt: 1, alignItems: 'center' }}>
        <Tooltip
          data={{
            text: `When you upvote posts you also bet coins on them. How much you bet can be decided automatically or manualy.`,
          }}
        >
          <Touchable style={{ zIndex: 1 }} onPress={toggleManualBet} td={'underline'}>
            <LinkFont sx={{ color: 'blue' }}>
              {isManualBet ? 'Disable' : 'Enable'} Betting Mode
            </LinkFont>
          </Touchable>
        </Tooltip>
      </Row>

      {!isNative && (
        <Row sx={{ mr: [1, 2], mt: 1, alignItems: 'center' }}>
          <Tooltip
            data={{
              text: `Staking and Vesting Interface. Use it to stake REL in order to earn rewards in the app and manage your vested tokens.`,
            }}
          >
            <InlineLink to={'https://stake.relevant.community'} external target="_blank">
              <LinkFont
                sx={{ color: 'blue', mr: 4.0001 }}
                // onPress={() => {
                //   dispatch(goToUrl('stake.relevant.community'));
                // }}
              >
                Staking & Vesting
              </LinkFont>
            </InlineLink>
          </Tooltip>
        </Row>
      )}
    </Row>
  );
}
